/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type CountdownApiProps = {
  technicalName?: Maybe<string>
  date: string
  tagline?: Maybe<string>
  title?: Maybe<string>
  text?: Maybe<string>
}

/* Schemas */
export const CountdownApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  date: z.string(),
  tagline: z.nullish(z.string()),
  title: z.nullish(z.string()),
  text: z.nullish(z.string()),
})

/* Schemas validation */
type TestCountdownProps = ExpectTrue<
  Equal<CountdownApiProps, z.infer<typeof CountdownApiPropsSchema>>
>
